/*
 * decimal-quantity-cart.js — página /cart (versão CBV app novo, REESCRITA LIMPA).
 * Substitui a implementação antiga (5683 linhas, 5-7 chamadas/edição + retry agressivo).
 * REUSA o núcleo window.DecimalCut (definido em decimal-quantity.js): prepararCorte
 * (resolve + sonda propagação + cache), cartAdd (retry gentil), getCartMeters (parse
 * decimal correto), pré-aquecimento. Mantém as features próprias da página: cupom,
 * subtotal, valor mínimo, desconto/PIX. O drawer é o carrinho principal; esta é a
 * página cheia (fallback), agora com os mesmos padrões sólidos.
 *
 * DOM (sections/decimal_quantity_cart.liquid): <form id="cart"> com <tr class="cart-item">
 * por linha. data-item-index = line da API Shopify. data-price-per-meter em CENTAVOS.
 * Modo edição = classe .editing no <tr>.
 */
if (!window.decimalQuantityCartInitialized) {
  window.decimalQuantityCartInitialized = true;

  (function () {
    'use strict';
    if (!document.getElementById('cart')) return; // só na página /cart

    const DC = () => window.DecimalCut;
    const parseBR = (v) => (DC() ? DC().parseBR(v) : (parseFloat(String(v == null ? '' : v).replace(',', '.').replace(/[^\d.]/g, '')) || 0));
    const fmtBR = (n) => (DC() ? DC().fmtBR(n) : (Number(n) || 0).toFixed(1).replace('.', ','));
    const brl = (n) => (DC() ? DC().brl(n) : new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(n) || 0));
    const round1 = (n) => Math.round((Number(n) || 0) * 10) / 10;

    let isUpdating = false;

    // ---------- helpers de linha ----------
    const productIdNum = (tr) => (tr.dataset.productId || '').toString().replace(/[^0-9]/g, '');

    // Preço/metro CONFIÁVEL = preço_da_linha ÷ metragem (ambos sempre corretos). NÃO
    // usamos a propriedade 'Valor por metro' (data-price-per-meter): ela pode estar
    // POLUÍDA por edições antigas (gravada como total, não por metro). Como o backend
    // reusa a variante por metragem, a variante fica certa mas a propriedade não —
    // então derivamos do preço da linha, e editar auto-corrige a propriedade.
    function ppmDom(tr) {
      const lp = parseFloat(tr.dataset.linePrice || '0'); // final_line_price em centavos
      const dq = parseFloat(tr.dataset.decimalQuantity || '0');
      if (lp > 0 && dq >= 0.5) return Math.round((lp / 100 / dq) * 100) / 100;
      return (parseFloat(tr.dataset.pricePerMeter || '0') || 0) / 100; // último recurso
    }
    // Versão à prova de desconto: usa item.price (preço da variante, sem desconto de
    // cupom) ÷ metragem, buscando no /cart.js. Cai pro ppmDom se não achar.
    async function precoMetroConfiavel(tr, cartPronto) {
      const key = tr.dataset.lineItemKey;
      try {
        const cart = cartPronto || await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        const item = key && (cart.items || []).find((i) => i.key === key);
        if (item && item.price > 0) {
          const q = item.properties && item.properties['_Quantidade'];
          const metros = q ? (parseFloat(String(q).replace(/[^\d.]/g, '')) || 0) : 0; // "8.0 metros" → 8.0
          if (metros >= 0.5) return Math.round((item.price / 100 / metros) * 100) / 100;
        }
      } catch (_) {}
      return ppmDom(tr);
    }

    /*
     * O balão de validação NUNCA aparecia nesta página. Duas incompatibilidades entre o
     * JS e o CSS (comprovado em 23/07/2026 medindo o estilo computado):
     *   1. `decimal-quantity-cart.css` deixa o balão em `opacity:0; visibility:hidden` e o
     *      revela pela classe `.visible` — mas o JS só alternava `hidden`. Resultado: a
     *      mensagem era escrita e ficava invisível.
     *   2. O tipo é CLASSE no CSS (.error/.warning/.success); gravar só `data-tipo` não
     *      pintava nada.
     * Sintoma para o cliente: pedir acima do estoque, clicar em Confirmar e não ver NADA
     * acontecer — parecia site quebrado, quando a validação estava certa o tempo todo.
     * Rastreia: validação invisível na /cart.
     */
    // `persistente` = não some sozinho em 4s. Necessário para o aviso de PROGRESSO, que
    // precisa durar o quanto durar a espera (a Shopify pode levar segundos publicando a
    // variante); quem mostrou é responsável por limpar.
    function mostrarTooltip(tr, msg, tipo, persistente) {
      // A linha tem DOIS balões: um no container do campo de quantidade (oculto no nosso
      // fluxo) e outro no de METROS, que é onde o cliente digita. Um querySelector solto
      // pegava o primeiro — o errado — e a mensagem era ancorada num controle invisível.
      const t = tr.querySelector('.quantity-input-container .stock-validation-tooltip')
             || tr.querySelector('.stock-validation-tooltip');
      if (!t) return;
      t.textContent = msg || '';
      t.classList.toggle('hidden', !msg);
      t.classList.toggle('visible', !!msg);
      t.classList.remove('error', 'warning', 'success');
      if (tipo) { t.classList.add(tipo); t.setAttribute('data-tipo', tipo); }
      if (msg && !persistente) setTimeout(() => { t.classList.add('hidden'); t.classList.remove('visible'); }, 4000);
    }

    /*
     * Limite que ESTA linha pode alcançar, já descontando as outras linhas do mesmo
     * produto. O Liquid grava em `data-max` do input (real_available).
     * CUIDADO: `data-available-quantity` da LINHA é o estoque BRUTO do produto — nesta
     * página os dois têm significados diferentes (no drawer não), e usar o errado faria o
     * aviso mentir para mais.
     */
    function limiteDaLinha(tr) {
      const input = tr.querySelector('.quantity-input');
      const m = parseFloat(input && input.dataset.max);
      return Number.isFinite(m) ? m : null;
    }

    /*
     * Valida AO VIVO enquanto o cliente ajusta, como o drawer já fazia. Antes só havia
     * checagem no Confirmar, e sem retorno visível: digitar 100 m num produto com 37 e
     * clicar em Confirmar não produzia NADA na tela. Escreve só quando a mensagem MUDA,
     * senão cada tecla reprogramaria o timer de 4s do balão.
     */
    function validarAoVivo(tr) {
      const input = tr.querySelector('.quantity-input');
      if (!input) return;
      const v = parseBR(input.value);
      const max = limiteDaLinha(tr);
      let msg = '';
      let tipo = 'error';
      if (Number.isFinite(v) && v > 0) {
        if (v < 0.5) msg = 'Quantidade mínima: 0,5 m';
        else if (max != null && v > max + 0.001) msg = `Máximo disponível: ${fmtBR(max)} m`;
      }
      const t = tr.querySelector('.quantity-input-container .stock-validation-tooltip')
             || tr.querySelector('.stock-validation-tooltip');
      const atual = t && t.classList.contains('visible') ? (t.textContent || '') : '';
      if (msg !== atual) mostrarTooltip(tr, msg, tipo);
    }

    /* Ao entrar em edição, diz quanto há disponível — em VERDE, porque é informação e não
       erro. Era a queixa "não me diz quanto tem de estoque quando estou preenchendo". */
    function avisarDisponivel(tr) {
      const max = limiteDaLinha(tr);
      if (max == null) return;
      mostrarTooltip(tr, `Disponível: ${fmtBR(max)} m`, 'success');
    }

    // Disponível pra ESTA linha crescer = estoque(metafield) − metros de OUTRAS linhas
    // do mesmo produto. Usa DecimalCut.getCartMeters (parse decimal correto, sem bug 10×).
    async function disponivelParaLinha(tr, cartPronto) {
      let totalCarrinho = 0;
      try { totalCarrinho = DC() ? await DC().getCartMeters(productIdNum(tr), cartPronto) : 0; } catch (_) {}
      const estaLinha = parseFloat(tr.dataset.decimalQuantity || '0') || 0;
      const outras = Math.max(0, round1(totalCarrinho - estaLinha));
      /*
       * `data-available-quantity` pode ser 0 LEGITIMAMENTE — tecido que esgotou com o
       * carrinho já aberto, que acontece o tempo todo (a notificação de estoque do Tiny
       * atualiza sozinha). O `|| 999999` que estava aqui transformava esse 0 em estoque
       * infinito: produto ESGOTADO passava a aceitar qualquer metragem. Era o caso que
       * mais importa acertar, e era exatamente o que falhava.
       * `Number.isFinite` é o guarda certo — é o mesmo que cart-drawer-decimal.js já usa
       * em corrigirEsgotadoFalso e no pré-aquecimento.
       * Atributo ausente/ilegível NÃO é estoque infinito: cai no que o carrinho já tem,
       * então dá para manter ou reduzir e não dá para aumentar sem lastro. É o mesmo
       * critério do Liquid quando a metragem é desconhecida.
       */
      const bruto = parseFloat(tr.dataset.availableQuantity);
      const metaDispo = Number.isFinite(bruto) ? bruto : totalCarrinho;
      return Math.max(0, round1(metaDispo - outras));
    }

    function setLoading(tr, on) {
      tr.querySelectorAll('.quantity-confirm, .quantity-cancel, .remove-item').forEach((b) => { b.disabled = !!on; });
      tr.classList.toggle('is-updating', !!on);
    }

    // ---------- re-render (section, mesma técnica do drawer) ----------
    async function refreshCart() {
      // PERF: o HTML da seção e o /cart.js do rodapé não dependem um do outro → disparam
      // JUNTOS em vez de um esperar o outro (~264ms a menos por ação). O rodapé continua
      // sendo escrito DEPOIS de trocar o innerHTML, senão o HTML novo apagaria o valor.
      const pCart = fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .catch(() => null);
      try {
        const html = await fetch('/cart?section_id=decimal_quantity_cart', { headers: { 'Cache-Control': 'no-cache' }, cache: 'no-store' }).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const novo = doc.querySelector('#cart');
        const atual = document.getElementById('cart');
        if (novo && atual) atual.innerHTML = novo.innerHTML;
        else { window.location.reload(); return; }
      } catch (_) { window.location.reload(); return; }
      /*
       * O `innerHTML` acima levou junto o cartão de Entrega: o HTML volta do Liquid
       * com o campo de CEP vazio e o resultado limpo. Quem já tinha calculado o frete
       * e mexeu na metragem veria o cartão "esquecer" o CEP.
       *
       * Só o CEP volta — a cotação não, de propósito: o carrinho mudou e o frete
       * depende do peso. Esta página não emite `cart:updated`, que é como o módulo se
       * inteira nos outros lugares, então aqui se avisa na mão.
       */
      try { if (window.cbvFrete) window.cbvFrete.preencherCepSalvo(); } catch (_) {}
      try { await sincronizarRodape((await pCart) || undefined); } catch (_) {}
    }

    // Atualiza subtotal exibido + mínimo + cupom/desconto a partir do /cart.js.
    // Aceita um carrinho JÁ LIDO (cartPronto) pra não repetir o GET de quem chamou;
    // sem argumento, lê por conta própria (comportamento antigo).
    async function sincronizarRodape(cartPronto) {
      let cart = cartPronto;
      if (!cart) {
        try { cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()); } catch (_) { return; }
      }

      // items_subtotal_price = mercadoria sem o desconto de PIX (por forma de
      // pagamento, só vale no checkout). total_price incluía o PIX e mostrava
      // subtotal menor pra todo mundo. Reflete cupom real de produto, não o PIX.
      // Consistente com o drawer e com o Liquid do mínimo. Rastreia: bug PIX no subtotal.
      /*
       * Quem ESCREVE a linha de Subtotal é o `cart-frete.js`, não este arquivo.
       *
       * Aqui só se informa a base, e ele soma o frete escolhido por cima antes de
       * escrever. Com dois escritores, a última chamada venceria e o frete apareceria
       * ou sumiria conforme a ordem em que resolvessem — bug que só dá as caras com a
       * rede lenta.
       *
       * `definirBase` também zera a cotação, e isso é deliberado: mudou a metragem, o
       * frete daquela consulta não vale mais porque depende do peso. Deixar o total
       * antigo na tela seria pior que não mostrar nada, porque ele continua parecendo
       * atual.
       *
       * O `else` não é enfeite: se o asset falhar em carregar, o subtotal continua
       * sendo escrito, só que sem frete.
       */
      if (window.cbvFrete) {
        window.cbvFrete.definirBase(cart.items_subtotal_price || 0);
      } else {
        const sub = document.querySelector('[data-cart-subtotal]');
        if (sub) sub.textContent = brl((cart.items_subtotal_price || 0) / 100);
      }

      // contador do header (fica FORA do #cart, então o refreshCart não o atualiza)
      const count = typeof cart.item_count === 'number' ? cart.item_count : (cart.items ? cart.items.length : 0);
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        try {
          el.textContent = String(count);
          el.setAttribute('data-cart-count', String(count));
          if (count > 0) { el.classList.remove('is-empty', 'hidden'); el.style.display = ''; }
          else { el.classList.add('is-empty'); }
        } catch (_) {}
      });

      // valor mínimo do pedido + botão de checkout
      const warn = document.getElementById('minimum-order-warning');
      const checkoutBtn = document.getElementById('checkout-button');
      if (warn) {
        const min = parseInt(warn.dataset.minimum || '0', 10) || 0;
        const base = cart.items_subtotal_price || cart.total_price || 0;
        const abaixo = min > 0 && base < min;
        warn.style.display = abaixo ? '' : 'none';
        if (checkoutBtn) {
          checkoutBtn.disabled = abaixo;
          checkoutBtn.classList.toggle('disabled', abaixo);
        }
      }

      // cupom / desconto (exclui PIX)
      // Os cupons da loja (CBV30/60/120, BOASVINDAS) são "desconto no valor do produto":
      // a Shopify os entrega em items[].line_level_discount_allocations, NUNCA em
      // cart_level_discount_applications — que aqui só traz o desconto automático do PIX.
      // Ler só o nível de carrinho escondia TODO cupom legítimo (cupom aplicado, desconto
      // real, e a tela não mostrava nada). O drawer já tem esse fallback
      // (cart-drawer-decimal.js:1183); a página não tinha. Rastreia: bug cupom sumido na /cart.
      // Soma por cupom porque a alocação é "each": num carrinho com N linhas o mesmo cupom
      // vira N alocações parciais — pegar só a primeira mostraria um valor menor que o real.
      const isPix = (d) => /pix/i.test((d && (d.title || d.code)) || '');
      const coupons = [];
      const somar = (title, amount) => {
        const j = coupons.find((c) => c.title === title);
        if (j) j.amount += amount;
        else coupons.push({ title, amount });
      };
      (cart.cart_level_discount_applications || []).forEach((d) => {
        if (!isPix(d)) somar(d.title, d.total_allocated_amount || 0);
      });
      (cart.items || []).forEach((it) => {
        (it.line_level_discount_allocations || []).forEach((a) => {
          const app = a.discount_application;
          // só código digitado: desconto automático vem com type "" (é o caso do PIX)
          if (app && app.type === 'discount_code' && !isPix(app)) somar(app.title, a.amount || 0);
        });
      });
      const appliedBox = document.getElementById('applied-coupon');
      const discountBox = document.getElementById('cart-decimal-discount');
      // O campo de digitar some enquanto há cupom aplicado: a Shopify aceita um código
      // por vez, e deixar o campo à vista convida a digitar um segundo que seria
      // recusado. Quem quiser trocar remove pelo "×" da etiqueta, e o campo volta.
      const cupomCorpo = document.getElementById('cupom-corpo');
      if (coupons.length) {
        const c = coupons[0];
        const code = document.getElementById('applied-coupon-code');
        if (code) code.textContent = String(c.title || '').toUpperCase();
        // `inline-flex`, não `flex`: a etiqueta é uma pílula que acompanha o título do
        // cartão na mesma linha. Em `flex` ela viraria bloco e ocuparia a linha toda.
        if (appliedBox) appliedBox.style.display = 'inline-flex';
        if (cupomCorpo) cupomCorpo.hidden = true;
        if (discountBox) {
          discountBox.style.display = 'flex';
          const dv = document.getElementById('discount-value');
          if (dv) dv.textContent = '-' + brl((c.amount || 0) / 100);
        }
      } else {
        if (appliedBox) appliedBox.style.display = 'none';
        if (cupomCorpo) cupomCorpo.hidden = false;
        if (discountBox) discountBox.style.display = 'none';
      }
    }

    // Auto-cura o "Produto esgotou" transitório (variante nova ainda propagando).
    function autoHeal(tentativas) {
      const n = typeof tentativas === 'number' ? tentativas : 4;
      if (n <= 0) return;
      setTimeout(async () => {
        if (!document.querySelector('#cart .out-of-stock-message')) return; // já curou
        await refreshCart();
        autoHeal(n - 1);
      }, 3500);
    }

    // ---------- edição de metragem ----------
    async function confirmarMetragem(tr) {
      if (isUpdating) return;
      const input = tr.querySelector('.quantity-input');
      if (!input) return;
      const novo = round1(parseBR(input.value));
      if (!(novo >= 0.5)) { mostrarTooltip(tr, 'Quantidade mínima: 0,5 m', 'error'); return; }

      // A trava liga ANTES do primeiro await (16/10/2026): ligada depois das leituras,
      // dois cliques em Confirmar (ou Enter + clique) passavam juntos e o mesmo corte
      // entrava duas vezes — as unidades se fundem numa linha de quantidade 2.
      isUpdating = true;

      // UMA leitura do carrinho serve para os DOIS usos abaixo (metros já no carrinho e
      // preço/metro real da linha). Antes eram dois GET /cart.js SEGUIDOS, ~250ms cada,
      // antes mesmo de o trabalho começar — parte do "demora muito" nesta página.
      let cartAgora = null;
      try { cartAgora = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()); } catch (_) {}

      let disp = 0;
      try { disp = await disponivelParaLinha(tr, cartAgora); } catch (_) { isUpdating = false; throw _; }
      if (novo > disp + 0.001) { isUpdating = false; mostrarTooltip(tr, `Máximo disponível: ${fmtBR(disp)} m`, 'error'); return; }
      if (!DC() || typeof DC().prepararCorte !== 'function') { isUpdating = false; mostrarTooltip(tr, 'Recarregue a página e tente de novo.', 'error'); return; }

      setLoading(tr, true);

      /* Avisos escalonados, como na PDP e no drawer. Aqui o cliente não tinha NENHUM
         retorno durante os ~2s (bem mais se a metragem for inédita): o botão parecia
         simplesmente não responder. Persistentes — quem mostra é quem limpa. */
      const avisos = [
        setTimeout(() => mostrarTooltip(tr, `Preparando seu corte de ${fmtBR(novo)} m…`, 'success', true), 1800),
        setTimeout(() => mostrarTooltip(tr, 'Primeira vez nesta medida — só mais um instante…', 'success', true), 4500),
      ];
      const limparAvisos = () => avisos.forEach(clearTimeout);

      try {
        const ppm = await precoMetroConfiavel(tr, cartAgora); // preço/metro real (evita propriedade poluída)
        const prep = await DC().prepararCorte(productIdNum(tr), novo, tr.dataset.productTitle || '', ppm, tr.dataset.productHandle || '');
        if (!prep.ready) {
          // variante nova não propagou a tempo → ABORTA sem tocar no carrinho (mantém o
          // valor anterior), evitando o estado quebrado (esgotou + subtotal 0).
          limparAvisos(); // senão um aviso de progresso sobrescreveria esta mensagem
          mostrarTooltip(tr, 'O corte está sendo preparado. Aguarde alguns segundos e tente novamente.', 'error');
          return;
        }
        // ADICIONA a nova PRIMEIRO e só depois remove a antiga (pela CHAVE, que o add não
        // muda). Até 16/10/2026 era o contrário: se o cartAdd falhasse (422, 429, ou a
        // conferência de preço do #6663), a antiga já tinha saído e o tecido sumia do
        // carrinho. Agora o cartAdd lança antes de qualquer remoção e o carrinho fica
        // como estava. Ver o mesmo trecho no cart-drawer-decimal.js.
        const key = tr.dataset.lineItemKey;
        const varLinha = (tr.querySelector('[data-variant-id]') || {}).dataset?.variantId || '';
        // Mesma variante = mesma metragem. Adicionar fundiria as linhas e o remove
        // apagaria a fundida: não mexe no carrinho.
        if (!(varLinha && String(varLinha) === String(prep.variantId))) {
          // o SKU da linha segue para a nova, como no drawer (sem ele a edição na /cart
          // apagava a propriedade SKU da linha)
          const linhaAtual = cartAgora && (cartAgora.items || []).find((i) => i.key === key);
          const skuLinha = linhaAtual && linhaAtual.properties && linhaAtual.properties.SKU ? String(linhaAtual.properties.SKU).trim() : undefined;
          const j = await DC().cartAdd(prep.variantId, novo, ppm, skuLinha);
          const chaveNova = j && Array.isArray(j.items) && j.items[0] ? j.items[0].key : null;
          if (key && key !== chaveNova) {
            let ok = false;
            for (let t = 0; t < 2 && !ok; t++) {
              try { ok = (await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) })).ok; } catch (_) {}
            }
            // remove falhou duas vezes: o corte novo está no carrinho; o refreshCart abaixo
            // mostra as duas linhas para a cliente excluir a que sobrou.
          }
        }
        limparAvisos();
        mostrarTooltip(tr, ''); // some o aviso antes de redesenhar
        await refreshCart();
        autoHeal();
      } catch (e) {
        limparAvisos();
        if (e && e.rateLimited) mostrarTooltip(tr, `Muitas tentativas. Aguarde ~${e.retryAfter}s e tente novamente.`, 'error');
        else mostrarTooltip(tr, 'Não foi possível atualizar. Tente novamente.', 'error');
      } finally {
        limparAvisos();
        isUpdating = false; setLoading(tr, false);
      }
    }

    /*
     * VOLTAR DE PÁGINA (back-forward cache): o navegador devolve a /cart como estava na
     * memória, com as linhas de antes. Quem excluiu em outra página e voltou via os itens
     * de novo (ver o mesmo bloco no cart-drawer-decimal.js). Só redesenha se as chaves na
     * tela divergirem do servidor: o refreshCart limpa a cotação de frete, e voltar sem
     * mudança no carrinho não deve custar a cotação que o cliente já fez.
     */
    window.addEventListener('pageshow', async (ev) => {
      if (!ev.persisted || isUpdating) return;
      let cart;
      try { cart = await fetch(`/cart.js?ts=${Date.now()}`, { headers: { Accept: 'application/json' }, cache: 'no-store' }).then((r) => r.json()); } catch (_) { return; }
      const naTela = [...document.querySelectorAll('#cart tr.cart-item[data-line-item-key]')].map((tr) => tr.dataset.lineItemKey).sort().join('|');
      const noServidor = (cart.items || []).map((i) => i.key).sort().join('|');
      if (naTela !== noServidor) await refreshCart();
    });

    // ---------- remover item ----------
    async function removerItem(tr) {
      if (isUpdating || !tr) return;
      isUpdating = true; setLoading(tr, true);
      try {
        const key = tr.dataset.lineItemKey; // pela chave (independe da ordem)
        if (key) await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) });
        await refreshCart();
      } catch (_) {} finally { isUpdating = false; }
    }

    // ---------- cupom ----------
    function mensagemCupom(msg, tipo) {
      let el = document.getElementById('coupon-message-cbv');
      if (!el) {
        const wrap = document.querySelector('.cart-decimal-coupon');
        if (!wrap) return;
        el = document.createElement('div');
        el.id = 'coupon-message-cbv';
        el.style.cssText = 'margin-top:6px;font-size:13px;';
        wrap.insertAdjacentElement('afterend', el);
      }
      el.textContent = msg || '';
      el.style.color = tipo === 'error' ? '#dc3545' : '#15803d';
      el.style.display = msg ? 'block' : 'none';
      if (msg) setTimeout(() => { el.style.display = 'none'; }, 4000);
    }
    function cupomLoading(on) {
      const txt = document.getElementById('coupon-text');
      const spin = document.getElementById('coupon-spinner');
      const btn = document.getElementById('coupon-button');
      if (txt) txt.style.display = on ? 'none' : '';
      if (spin) spin.style.display = on ? 'inline-flex' : 'none';
      if (btn) btn.disabled = !!on;
    }
    /*
     * O cupom digitado REALMENTE entrou no carrinho?
     *
     * Procura nos DOIS níveis. Os cupons da CBV (CBV30/60/120, BOASVINDAS) são
     * "desconto no valor do produto" e caem em items[].line_level_discount_allocations;
     * só desconto de PEDIDO cai em cart_level_discount_applications. Olhar só o nível de
     * carrinho — que era o que esta função fazia — REPROVAVA cupom válido e ainda o
     * removia no rollback: o cliente digitava o código certo, ouvia "inválido" e perdia
     * o desconto que a Shopify já tinha aceitado. Mesma armadilha cart_level × line_level
     * que escondia o cupom na exibição (ver sincronizarRodape).
     */
    function cupomNoCarrinho(cart, code) {
      const alvo = String(code || '').trim().toLowerCase();
      if (!alvo || !cart) return false;
      const bate = (app) => !!app && String(app.title || app.code || '').trim().toLowerCase() === alvo;
      if ((cart.cart_level_discount_applications || []).some(bate)) return true;
      return (cart.items || []).some((it) =>
        (it.line_level_discount_allocations || []).some((a) => bate(a.discount_application)));
    }

    // Título do cupom que já estava valendo (null se não houver). Exige
    // type "discount_code": desconto automático vem com type "" — é o caso do PIX,
    // que não é cupom e não pode ser "restaurado".
    function cupomVigente(cart) {
      if (!cart) return null;
      const doCarrinho = (cart.cart_level_discount_applications || []).find((d) => d && d.type === 'discount_code');
      if (doCarrinho) return doCarrinho.title || null;
      for (const it of cart.items || []) {
        for (const a of it.line_level_discount_allocations || []) {
          const app = a.discount_application;
          if (app && app.type === 'discount_code') return app.title || null;
        }
      }
      return null;
    }

    async function aplicarCupom(code) {
      code = (code || '').trim();
      if (!code) { mensagemCupom('Digite um cupom.', 'error'); return; }
      cupomLoading(true);
      const mandarCupom = (discount) => fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: discount }) });
      const lerCarrinho = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      try {
        // A Shopify guarda UM código por carrinho: tentar um código novo derruba o que
        // estava valendo. Guarda o anterior pra devolver caso o novo não cole.
        let anterior = null;
        // sem saber o cupom vigente, não arrisca: lê de novo e, se falhar outra vez, cai no
        // catch sem mandar o código novo (que derrubaria o vigente sem como devolver)
        try { anterior = cupomVigente(await lerCarrinho()); } catch (_) { anterior = cupomVigente(await lerCarrinho()); }

        await mandarCupom(code);
        const cart = await lerCarrinho();
        if (!cupomNoCarrinho(cart, code)) {
          // rollback pra não deixar um discount inválido preso na sessão, restaurando
          // o cupom anterior (ou limpando, se não havia)
          await mandarCupom(anterior || '');
          await refreshCart();
          mensagemCupom('Cupom inválido ou não aplicável.', 'error');
        } else {
          await refreshCart();
          mensagemCupom('Cupom aplicado!', 'success');
        }
      } catch (_) {
        mensagemCupom('Erro ao aplicar o cupom. Tente novamente.', 'error');
      } finally {
        cupomLoading(false);
      }
    }
    async function removerCupom() {
      const icon = document.getElementById('remove-icon');
      const spin = document.getElementById('remove-spinner');
      if (icon) icon.style.display = 'none';
      if (spin) spin.style.display = 'inline-flex';
      try {
        await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) });
        await refreshCart();
      } catch (_) {}
    }

    // ---------- pré-aquecimento da edição (mesma ideia do drawer/PDP) ----------
    let preAquecerTimer = null;
    function preAquecer(tr) {
      if (!DC() || typeof DC().preAquecerCorte !== 'function') return;
      clearTimeout(preAquecerTimer);
      preAquecerTimer = setTimeout(() => {
        const input = tr.querySelector('.quantity-input');
        if (!input) return;
        const metros = round1(parseBR(input.value));
        if (!(metros >= 0.5)) return;
        // Pré-aquecer CRIA variante no catálogo — nunca acima do estoque. Sem este teto,
        // digitar "60" criava "6.0" e "60.0 metros" de verdade, mesmo sem ir ao carrinho,
        // queimando vagas do limite de 100. Rastreia: variantes fantasma.
        const max = limiteDaLinha(tr);
        if (max != null && metros > max + 0.001) return;
        DC().preAquecerCorte(productIdNum(tr), metros, tr.dataset.productTitle || '', ppmDom(tr), tr.dataset.productHandle || '');
        // 1200ms > o ajuste automático de 1s, para aquecer o valor já corrigido
      }, 1200);
    }

    // ---------- wiring (delegação no document — sobrevive aos re-renders) ----------
    document.addEventListener('click', (ev) => {
      const alvo = ev.target;
      if (!alvo || !alvo.closest) return;

      // cupom (fora da linha)
      if (alvo.closest('#coupon-button')) {
        ev.preventDefault();
        const inp = document.getElementById('coupon-input');
        aplicarCupom(inp ? inp.value : '');
        return;
      }
      if (alvo.closest('#remove-coupon-btn')) { ev.preventDefault(); removerCupom(); return; }

      const tr = alvo.closest('#cart .cart-item');
      if (!tr) return;

      if (alvo.closest('.quantity-edit-button')) {
        ev.preventDefault();
        tr.classList.add('editing');
        const input = tr.querySelector('.quantity-input');
        if (input) { input.focus(); input.select(); }
        avisarDisponivel(tr); // mostra o limite ANTES de o cliente digitar
        return;
      }
      if (alvo.closest('.quantity-cancel')) {
        ev.preventDefault();
        tr.classList.remove('editing');
        const input = tr.querySelector('.quantity-input');
        if (input && input.dataset.originalValue) input.value = fmtBR(parseFloat(input.dataset.originalValue));
        mostrarTooltip(tr, '');
        return;
      }
      if (alvo.closest('.quantity-confirm')) { ev.preventDefault(); confirmarMetragem(tr); return; }
      if (alvo.closest('.remove-item') || alvo.closest('.quantity-delete-button')) { ev.preventDefault(); removerItem(tr); return; }

      const btnMais = alvo.closest('.quantity-button.plus');
      const btnMenos = alvo.closest('.quantity-button.minus');
      if (btnMais || btnMenos) {
        ev.preventDefault();
        const input = tr.querySelector('.quantity-input');
        if (!input) return;
        const step = parseFloat(input.dataset.step || '0.1') || 0.1;
        let v = round1(parseBR(input.value) + (btnMais ? step : -step));
        // TRAVA no limite em vez de só avisar: o piso já parava em 0,5, mas o teto não
        // existia e dava para subir indefinidamente acima do estoque, descobrindo só no
        // Confirmar. `limiteDaLinha` lê o data-max (disponível já descontando as outras
        // linhas do mesmo produto).
        const max = limiteDaLinha(tr);
        let travou = false;
        if (v < 0.5) { mostrarTooltip(tr, 'Quantidade mínima: 0,5 m', 'error'); v = 0.5; travou = true; }
        else if (max != null && v > max) { v = round1(Math.max(0.5, max)); mostrarTooltip(tr, `Disponível: ${fmtBR(v)} m`, 'error'); travou = true; }
        input.value = fmtBR(v);
        // Só valida ao vivo se NÃO travou: depois de travar o valor é válido por definição,
        // e a validação limparia o aviso que acabou de explicar por que o botão parou.
        if (!travou) validarAoVivo(tr);
        preAquecer(tr);
      }
    });

    // digitação direta no input de metros → pré-aquece
    document.addEventListener('input', (ev) => {
      const input = ev.target;
      if (input && input.classList && input.classList.contains('quantity-input')) {
        const tr = input.closest('#cart .cart-item');
        if (tr) {
          validarAoVivo(tr);
          preAquecer(tr);
          /* Ajuste ATRASADO ao máximo (mesma lógica do drawer): travar a cada tecla
             brigaria com quem digita "45" — ao teclar "4" já corrigiria. Espera a
             digitação parar (1s) e baixa para o disponível, dizendo o porquê. Só o
             MÁXIMO: corrigir o mínimo assim viraria "0,5" no meio da digitação de "0,5".
             Timer no próprio campo para não cancelar o ajuste de outra linha. */
          clearTimeout(input._timerMax);
          input._timerMax = setTimeout(() => {
            const max = limiteDaLinha(tr);
            const v = parseBR(input.value);
            if (max == null || !Number.isFinite(v) || v <= max) return;
            input.value = fmtBR(max);
            mostrarTooltip(tr, `Disponível: ${fmtBR(max)} m`, 'error');
          }, 1000);
        }
      }
    });

    /* Ao SAIR do campo, normaliza a exibição para pt-BR: "3.4"/"20.7" viram "3,4"/"20,7".
       parseBR já entende ponto como decimal; aqui só reescreve o que aparece. Usa
       `focusout` (não `blur`) porque a /cart delega no document e blur não borbulha. */
    document.addEventListener('focusout', (ev) => {
      const input = ev.target;
      if (!input || !input.classList || !input.classList.contains('quantity-input')) return;
      const tr = input.closest('#cart .cart-item');
      if (!tr) return;
      clearTimeout(input._timerMax);
      const v = round1(parseBR(input.value));
      if (!(v >= 0.5)) return; // vazio/inválido: deixa pro fluxo de erro do Confirmar
      const max = limiteDaLinha(tr);
      // Digitou acima do estoque → trava no máximo E AVISA (antes travava calado).
      if (max != null && v > max) {
        input.value = fmtBR(max);
        mostrarTooltip(tr, `Disponível: ${fmtBR(max)} m`, 'error');
      } else {
        input.value = fmtBR(v);
      }
    });

    // cupom via Enter
    document.addEventListener('keydown', (ev) => {
      if (ev.key === 'Enter' && ev.target && ev.target.id === 'coupon-input') {
        ev.preventDefault();
        aplicarCupom(ev.target.value);
      }
    });

    /*
     * Enter numa LINHA confirma a edição daquela linha — e nunca envia o form.
     * Medido em 16/10/2026 com teclado de verdade: editar o Crepe Bubble para 3,5 e
     * apertar Enter APAGOU o Crepe Misto (outra linha) e não aplicou a edição. O campo
     * de metros mora dentro do <form id="cart">, e o navegador faz o "envio implícito":
     * dispara um clique no primeiro botão submit do form — que era a lixeira (sem
     * type) da primeira linha de corte. As lixeiras viraram type="button", mas aí o
     * botão padrão passa a ser o Finalizar: sem este ouvinte, o Enter mandaria a
     * cliente ao checkout no meio da edição. O drawer já confirma com Enter; a /cart
     * passa a fazer o mesmo. CEP e cupom têm os ouvintes deles.
     */
    document.addEventListener('keydown', (ev) => {
      if (ev.key !== 'Enter' || !ev.target || !ev.target.closest) return;
      const campo = ev.target;
      if (campo.tagName !== 'INPUT' || !campo.closest('#cart')) return;
      if (campo.id === 'coupon-input' || campo.closest('.cbv-frete__cep')) return;
      ev.preventDefault();
      const tr = campo.closest('#cart .cart-item');
      if (!tr) return;
      if (campo.classList.contains('quantity-input')) {
        if (tr.classList.contains('editing')) confirmarMetragem(tr);
        return;
      }
      const ok = tr.querySelector('[data-real-quantity-confirm]');
      if (ok && campo.matches('[data-real-quantity-input]')) ok.click();
    });

    // bloqueia o checkout enquanto uma edição está em andamento
    const form = document.getElementById('cart');
    if (form) form.addEventListener('submit', (ev) => { if (isUpdating) ev.preventDefault(); });

    // estado inicial (mostra mínimo/cupom conforme o carrinho)
    sincronizarRodape().catch(() => {});
  })();
}
